import React from "react";
import { Box } from "../box";
import { Flex } from "../flex";

// https://dribbble.com/shots/20456228-Audit-trail
// https://dribbble.com/shots/18901487-Attio-Record-Activity-Feed
// https://dribbble.com/shots/20146723-Sales-Status-Ditto-CRM

export interface TimelineProps<T> {
  items: Array<T>;
  render?(item: T): React.ReactNode;
  labelKey?: keyof T;
  getIndicator?(item: T): React.ReactNode;
  hideLastItemTail?: boolean;
}

export function Timeline<T>({
  items,
  render,
  labelKey,
  getIndicator,
  hideLastItemTail = true,
}: TimelineProps<T>) {
  return (
    <Box>
      {items.map((item, index) => {
        const indicator = getIndicator?.(item) ?? (
          <div color={"blue"} data-variant={"outline"} />
        );

        const content =
          render?.(item) ?? (item[labelKey as keyof T] as React.ReactNode);

        const isLast = index === items.length - 1;

        return (
          <Flex className="p-timeline-item" key={index}>
            <Flex align={"center"} stack>
              <Flex className="p-timeline-indicator-container">
                {indicator}
              </Flex>

              {isLast && hideLastItemTail ? null : (
                <div className="p-timeline-item-tail" />
              )}
            </Flex>

            <Flex stretchX className="p-timeline-item-content">
              {content}
            </Flex>
          </Flex>
        );
      })}
    </Box>
  );
}
